import React, { useState } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import ServicesAccordion from "@/components/site/ServicesAccordion";
import SymptomPicker from "@/components/site/SymptomPicker";
import TrustBadges from "@/components/site/TrustBadges";
import Faq from "@/components/site/Faq";
import Footer from "@/components/site/Footer";
import CallNowButton from "@/components/site/CallNowButton";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const scrollToBooking = () => {
  const el = document.getElementById("booking");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function PremiumAutoWorks() {
  const [symptomTopic, setSymptomTopic] = useState("");

  const handleSymptomPick = (label) => {
    setSymptomTopic(label);
    scrollToBooking();
  };

  return (
    <div className="min-h-screen bg-[#121212] text-white font-body">
      <Navbar onBookClick={scrollToBooking} />
      <Hero symptomTopic={symptomTopic} api={API} />
      <ServicesAccordion />
      <SymptomPicker onPick={handleSymptomPick} />
      <TrustBadges />
      <Faq />
      <Footer />
      <CallNowButton />
    </div>
  );
}
